import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';

import {
    uploadFRY7QData, uploadFRY9CData, uploadFFIEC031Data, uploadFFIEC041Data, uploadMetro2Data, uploadFFIEC009Data, uploadFR2052AData,
} from '../../actions';
import { selectValueVar, tenantIdVar } from '../../Apollo/config';
import ReportConformationModal from './ReportConformationModal';
import leftChevron from '../../assets/images/left-chevron.svg';
import FRY7QUploadTabThree from './regulations/FRY7Q/FRY7QUploadTabThree';
import Metro2UploadTabThree from './regulations/METRO2/Metro2UploadTabThree';
import FFIEC009UploadTabThree from './regulations/FFIEC009/FFIEC009UploadTabThree';
import FR2052AUploadTabThree from './regulations/FR2052A/FR2052AUploadTabThree';
import FRY9CUploadTabThree from './regulations/FRY9C/FRY9CUploadTabThree';
import FFIEC031UploadTabThree from './regulations/FFIEC031/FFIEC031UploadTabThree';
import FFIEC041UploadTabThree from './regulations/FFIEC041/FFIEC041UploadTabThree';

import './datepicker.scss';

const UploadTabThree = ({
    setTab, selectValue,
}) => {
    const [fileName, setFileName] = useState('');
    const [file, setFile] = useState('');
    const [tier, setTier] = useState('n');
    const [leave, setLeave] = useState(false);
    const [selectedQtr, setSelectedQtr] = useState(new Date());
    const [reportConformationModal, setReportConformationModal] = useState(false);
    const tenantId = useReactiveVar(tenantIdVar);
    const history = useHistory();
    const [finalRuleOnly, setFinalRuleOnly] = useState(false);
    const [advanced, setAdvanced] = useState('');
    const [nonAdvanced, setNonAdvanced] = useState('');
    const [grandFathered, setGrandFathered] = useState(false);
    const [foreignGsib, setForeignGsib] = useState('');
    const [topTierBhc, setTopTierBhc] = useState('');
    const [exitParallel, setExitParallel] = useState('');
    const [cat3Hc, setCat3Hc] = useState('');
    const [noCblrOnly, setNoCblrOnly] = useState('');
    const [cat123Only, setCat123Only] = useState('');
    const [institution, setInstitution] = useState('');

    const ques1 = (e, value) => {
        if (value === 'No') {
            setFinalRuleOnly(false);
        } else {
            setFinalRuleOnly(true);
        }
    };

    const ques2 = (e, value) => {
        if (value === 'No') {
            setAdvanced(false);
        } else {
            setAdvanced(true);
        }
    };

    const ques3 = (e, value) => {
        if (value === 'No') {
            setNonAdvanced(false);
        } else {
            setNonAdvanced(true);
        }
    };
    const ques4 = (e, value) => {
        if (value === 'No') {
            setGrandFathered(false);
        } else {
            setGrandFathered(true);
        }
    };

    const ques5 = (e, value) => {
        if (value === 'No') {
            setForeignGsib(false);
        } else {
            setForeignGsib(true);
        }
    };

    const ques6 = (e, value) => {
        if (value === 'No') {
            setTopTierBhc(false);
        } else {
            setTopTierBhc(true);
        }
    };

    const ques7 = (e, value) => {
        if (value === 'No') {
            setExitParallel(false);
        } else {
            setExitParallel(true);
        }
    };

    const ques8 = (e, value) => {
        if (value === 'No') {
            setCat3Hc(false);
        } else {
            setCat3Hc(true);
        }
    };

    const ques9 = (e, value) => {
        if (value === 'No') {
            setNoCblrOnly(false);
        } else {
            setNoCblrOnly(true);
        }
    };

    const ques10 = (e, value) => {
        if (value === 'No') {
            setCat123Only(false);
        } else {
            setCat123Only(true);
        }
    };

    const onSelectInstitution = value => {
        setInstitution(value);
    };

    // const disableUploadButton = ((advanced === '') || (nonAdvanced === '') || (institution === 'ihc' && foreignGsib === '')
    //     || (cat123Only === '') || (cat3Hc === '')
    //     || (noCblrOnly === '') || (exitParallel === '') || (topTierBhc === '') || !fileName);

    const disableUploadButton = (((selectValue === 'FR Y-9C' || selectValue === 'FFIEC 031') && advanced === '') || (nonAdvanced === '')
    || (selectValue === 'FR Y-9C' && institution === 'ihc' && foreignGsib === '')
    || (selectValue === 'FR Y-9C' && cat123Only === '')
    || (institution === 'ihc' && cat3Hc === '') || (institution === 'ihc'
    && noCblrOnly === '') || ((selectValue === 'FR Y-9C' || selectValue === 'FFIEC 031')
    && institution === 'ihc' && exitParallel === '') || (selectValue === 'FR Y-9C' && institution === 'ihc' && topTierBhc === '') || !fileName);

    /* function to handle file selection event */
    const handleFileUpload = Event => {
        setFileName(Event.target.files[0].name);
        setFile(Event.target.files[0]);
    };

    /* function to handle deletion of uploaded file and show confirmation alert */
    const onHandleReportClose = () => {
        setReportConformationModal(true);
        setLeave(false);
    };

    /* function to handle regulation report upload event for different regulations */
    const onHandleUpload = async () => {
        // eslint-disable-next-line camelcase
        const { name } = selectValueVar();
        let pathName;
        const quarter = Math.floor(selectedQtr.getMonth() / 3 + 1);
        const year = selectedQtr.getFullYear();
        const qtrValue = `q${quarter}_${year}`;
        const month = selectedQtr.getMonth() + 1;
        const monthValue = `${month}_${year}`;
        if (selectValue === 'FR Y-7Q') {
            const payload = {
                regulatorName: name,
                period: qtrValue,
                topTierFlag: tier,
                files: file,
                tenantId,
            };
            await uploadFRY7QData(payload);
            pathName = '/fry7q';
        } else if (selectValue === 'FR Y-9C') {
            const payload = {
                regulatorName: name,
                period: qtrValue,
                files: file,
                tenantId,
                institution,
                finalRuleOnly,
                advanced,
                nonAdvanced,
                grandFathered,
                foreignGsib,
                topTierBhc,
                exitParallel,
                cat3Hc,
                noCblrOnly,
                cat123Only,
            };
            await uploadFRY9CData(payload);
            pathName = '/fry9c';
        } else if (selectValue === 'FFIEC 031') {
            const payload = {
                regulatorName: name,
                period: qtrValue,
                files: file,
                tenantId,
                institution,
                finalRuleOnly,
                advanced,
                nonAdvanced,
                exitParallel,
                cat3Hc,
                noCblrOnly,
            };
            await uploadFFIEC031Data(payload);
            pathName = '/ffiec031';
        } else if (selectValue === 'FFIEC 041') {
            const payload = {
                regulatorName: name,
                period: qtrValue,
                files: file,
                tenantId,
                institution,
                finalRuleOnly,
                nonAdvanced,
                cat3Hc,
                noCblrOnly,
            };
            await uploadFFIEC041Data(payload);
            pathName = '/ffiec041';
        } else if (selectValue === 'Metro2') {
            const payload = {
                regulatorName: name,
                files: file,
                tenantId,
                period: monthValue,
            };
            await uploadMetro2Data(payload);
            pathName = '/metro2';
        } else if (selectValue === 'FFIEC009') {
            const payload = {
                regulatorName: name,
                period: qtrValue,
                files: file,
                tenantId,
            };
            await uploadFFIEC009Data(payload);
            pathName = '/FFIEC009';
        } else if (selectValue === 'FR 2052a') {
            const payload = {
                regulatorName: name,
                period: qtrValue,
                files: file,
                tenantId,
            };
            await uploadFR2052AData(payload);
            pathName = '/fr2052a';
        } else {
            pathName = '';
        }
        history.push({
            pathname: pathName,
            state: {
                regulation: selectValue,
            },
        });
    };

    /* function to handle go back event */
    const onHandleBack = () => {
        if (fileName) {
            setReportConformationModal(true);
            setLeave(true);
        } else {
            setTab('second');
        }
    };
    if (reportConformationModal) {
        return (
            <ReportConformationModal
                setReportConformationModal={setReportConformationModal}
                setFileName={setFileName}
                leave={leave}
                setLeave={setLeave}
                setTab={setTab}
            />
        );
    }
    return (
        <div className="true-comply-upload__steptwo true-comply-upload__stepthree" data-testid="upload-tab3">
            <div className="true-comply-upload__steptwo-back" onClick={onHandleBack} aria-hidden="true" data-testid="handle-back">
                <img src={leftChevron} alt="leftChevron" />
                Back
            </div>
            {selectValue === 'FR Y-7Q' && (
                <FRY7QUploadTabThree
                    fileName={fileName}
                    onHandleUpload={onHandleUpload}
                    selectedQtr={selectedQtr}
                    setSelectedQtr={setSelectedQtr}
                    tier={tier}
                    setTier={setTier}
                    handleFileUpload={handleFileUpload}
                    onHandleReportClose={onHandleReportClose}
                />
            )}
            {selectValue === 'FR Y-9C' && (
                <FRY9CUploadTabThree
                    fileName={fileName}
                    onHandleUpload={onHandleUpload}
                    selectedQtr={selectedQtr}
                    setSelectedQtr={setSelectedQtr}
                    handleFileUpload={handleFileUpload}
                    onHandleReportClose={onHandleReportClose}
                    disableUploadButton={disableUploadButton}
                    ques1={ques1}
                    ques2={ques2}
                    ques3={ques3}
                    ques4={ques4}
                    ques5={ques5}
                    ques6={ques6}
                    ques7={ques7}
                    ques8={ques8}
                    ques9={ques9}
                    ques10={ques10}
                    institution={institution}
                    onSelectInstitution={onSelectInstitution}
                    advanced={advanced}
                    nonAdvanced={nonAdvanced}
                    exitParallel={exitParallel}
                />
            )}
            {selectValue === 'FFIEC 031' && (
                <FFIEC031UploadTabThree
                    fileName={fileName}
                    onHandleUpload={onHandleUpload}
                    selectedQtr={selectedQtr}
                    setSelectedQtr={setSelectedQtr}
                    handleFileUpload={handleFileUpload}
                    onHandleReportClose={onHandleReportClose}
                    disableUploadButton={disableUploadButton}
                    ques1={ques1}
                    ques2={ques2}
                    ques3={ques3}
                    ques7={ques7}
                    ques8={ques8}
                    ques9={ques9}
                    institution={institution}
                    onSelectInstitution={onSelectInstitution}
                    advanced={advanced}
                    nonAdvanced={nonAdvanced}
                    exitParallel={exitParallel}
                />
            )}
            {selectValue === 'FFIEC 041' && (
                <FFIEC041UploadTabThree
                    fileName={fileName}
                    onHandleUpload={onHandleUpload}
                    selectedQtr={selectedQtr}
                    setSelectedQtr={setSelectedQtr}
                    handleFileUpload={handleFileUpload}
                    onHandleReportClose={onHandleReportClose}
                    disableUploadButton={disableUploadButton}
                    ques1={ques1}
                    ques3={ques3}
                    ques8={ques8}
                    ques9={ques9}
                    institution={institution}
                    onSelectInstitution={onSelectInstitution}
                    advanced={advanced}
                    nonAdvanced={nonAdvanced}
                    exitParallel={exitParallel}
                />
            )}
            {selectValue === 'Metro2' && (
                <Metro2UploadTabThree
                    fileName={fileName}
                    onHandleUpload={onHandleUpload}
                    handleFileUpload={handleFileUpload}
                    onHandleReportClose={onHandleReportClose}
                    selectedQtr={selectedQtr}
                    setSelectedQtr={setSelectedQtr}
                />
            )}
            {selectValue === 'FFIEC009' && (
                <FFIEC009UploadTabThree
                    fileName={fileName}
                    onHandleUpload={onHandleUpload}
                    selectedQtr={selectedQtr}
                    setSelectedQtr={setSelectedQtr}
                    handleFileUpload={handleFileUpload}
                    onHandleReportClose={onHandleReportClose}
                />
            )}
            {selectValue === 'FR 2052a' && (
                <FR2052AUploadTabThree
                    fileName={fileName}
                    onHandleUpload={onHandleUpload}
                    selectedQtr={selectedQtr}
                    setSelectedQtr={setSelectedQtr}
                    handleFileUpload={handleFileUpload}
                    onHandleReportClose={onHandleReportClose}
                />
            )}
        </div>
    );
};

export default UploadTabThree;
